import React from "react"
import { useTheme } from "styled-components"
import StarIcon from "images/star-filled-icon.svg"
import ImagePreload from "components/image-preload"
import { showStarsInsteadOfAsterisks } from "utils/showStarsInsteadOfAsterisks"

import { useComponentizedPage } from "store/contexts/componentized-page"
import {
  BackgroundContainer,
  BackgroundImage,
  Horizontal,
  Left,
  StyledHeroContent,
  Right,
  Overlay,
  ButtonsContainer,
} from "./styles"

const TextAndImage = ({
  preheading,
  heading,
  subheading,
  body,
  buttonElement,
  secondaryButtonElement,
  signupForm,
  mediaType,
  mediaElement,
  reverseOrder,
  backgroundImages,
  variantLeft,
  variantRight,
  minHeight,
  hasOverlay,
  elRef,
  dataId,
  hideOnPageLoad,
  dataExpId,
  review,
  verticalAlign,
  applyTopBottomPadding,
  applyMediaPadding,
  topBar,
  isShop,
  featureHighlights,
  isLayoutContainer,
  ...props
}) => {
  const theme = useTheme()
  const bgImages = backgroundImages && [
    {
      screenSize: 993,
      url: backgroundImages.desktop,
      transforms: `c_fill,g_auto,w_1440,h_${minHeight || 500},q_90,f_auto,fl_lossy`,
    },
    {
      screenSize: 500,
      url: backgroundImages.tablet,
      transforms: "c_fill,g_auto,w_992,h_1000,q_90,f_auto,fl_lossy",
    },
    {
      url: backgroundImages.mobile,
      transforms: "c_fill,g_auto,w_500,h_700,q_90,f_auto,fl_lossy",
    },
  ]
  const { isHomePage } = useComponentizedPage()

  return (
    <BackgroundContainer
      hideOnPageLoad={hideOnPageLoad}
      data-exp-id={dataId}
      ref={elRef}
      minHeight={minHeight}
      {...props}
    >
      {theme.component?.onTop && bgImages && <ImagePreload images={bgImages} />}
      {bgImages && <BackgroundImage images={bgImages} alt="" lazy={!theme.component.onTop} />}
      {hasOverlay && <Overlay />}
      {topBar}
      <Horizontal
        data-exp-id={dataExpId}
        applyTopBottomPadding={applyTopBottomPadding}
        verticalAlign={verticalAlign}
      >
        <Left
          preHeadingStyle={preheading.style}
          variant={variantLeft}
          secondaryButtonElement={!!secondaryButtonElement}
          isShop={isShop}
        >
          <StyledHeroContent
            preheading={showStarsInsteadOfAsterisks(preheading, StarIcon)}
            heading={heading}
            subheading={subheading}
            body={body}
            isShop={isShop}
            featureHighlights={featureHighlights}
            isLayoutContainer={isLayoutContainer}
            buttonElement={buttonElement}
            isHomePage={isHomePage}
          />
          {review}
          {!isLayoutContainer && secondaryButtonElement ? (
            <ButtonsContainer variant={variantLeft}>
              {buttonElement}
              {secondaryButtonElement}
            </ButtonsContainer>
          ) : (
            !isLayoutContainer && buttonElement
          )}
          {signupForm}
        </Left>
        <Right
          variantRight={variantRight}
          reverseOrder={reverseOrder}
          applyMediaPadding={applyMediaPadding}
        >
          {mediaElement}
        </Right>
      </Horizontal>
    </BackgroundContainer>
  )
}

export default TextAndImage
